import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

// initial load User Profile/Two-Factor Authentication page
const getMfaUserInfo = async (token) => {

  let status = STATUSES.SUCCESS;
  let body = {};

  const url = "/api/mfa/getUserSmsFactorMobile";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getMfaUserInfo()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// Set up phone request
const setupUserSmsFactor = async (token, request) => {

  let status = STATUSES.SUCCESS;
  let body = request;

  const url = "/api/mfa/setupUserSmsFactor";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {
    //console.log("setupUserSmsFactor()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// verify the new phone device
const submitMfa = async (token, mfaToken, userEmail) => {

  let status = STATUSES.SUCCESS;
  /*{
    "email":userEmail,
    "token":mfaToken
  }*/
  let body = {
    "email": userEmail,
    "token": mfaToken
  }

  const url = "/api/mfa/verifyUserSmsFactorToken";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};




export { getMfaUserInfo, setupUserSmsFactor, submitMfa }